export class ToggleMenu {
    public static readonly type = '[Admin] ToggleMenu';
}

export class ToggleNotifications {
    public static readonly type = '[Admin] ToggleNotifications';
    constructor(public show?: boolean) {}
}
